import 'core-js/es/object';
import 'core-js/es/array';
import 'core-js/es/string/includes';
import React from 'react';
import styled from 'styled-components';
import { LangWidget, CabinetWidget, Login } from './pages';
import { Provider } from 'react-redux';
import { Styles } from './styles';
import { setSubscribes } from '../../subscribes';

setSubscribes(window.sharedStore);

export const App = () => (
  <Provider store={window.sharedStore}>
    <Styles />
    <Widgets>
      <LangWidget />
      {!window._user.id && <Login />}
      {!!window._user.id && <CabinetWidget />}
    </Widgets>
  </Provider>
);

const Widgets = styled.div`
  display: flex;
  align-items: center;
`;
